import { render, staticRenderFns } from "./manage_selected_account_owner_modal.vue?vue&type=template&id=5fd97cc5&scoped=true"
import script from "./manage_selected_account_owner_modal.vue?vue&type=script&lang=js"
export * from "./manage_selected_account_owner_modal.vue?vue&type=script&lang=js"
import style0 from "./manage_selected_account_owner_modal.vue?vue&type=style&index=0&id=5fd97cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd97cc5",
  null
  
)

export default component.exports